import * as React from 'react';
import { Box } from '@material-ui/core';
import { Route, Switch, useLocation, useParams, useHistory, Redirect } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { usePaginatedQuery, useQueryParams } from '../../../hooks';
import { cleanShipmentGroup } from '../../../actions/shipmentGroupActions';
import accountProductsApi from '../../../apis/swagup/accountProducts';
import apiPaths from '../../../helpers/apiPaths';
import Loader from '../../global/Loader';
import ShipmentsReview from '../../directory/shipmentsReview/ShipmentsReview';
import SelectProducts from '../orders/requested/shipments/SelectProducts';
import SelectRecipients from '../orders/requested/shipments/SelectRecipients';
import Stepper from '../../shared/Stepper';
import TopBar from '../../shared/TopBar';
import { mapProductToProof } from '../orders/requested/common/utilsOrder';

const perPageOptions = [12, 24, 36, 48];
const SelectProductsWrapper = () => {
  const query = useQueryParams();
  const search = query.get('search') || '';
  const recordTypeParams = query.get('product_type')?.split(',') ?? [];
  const recordType = recordTypeParams?.length === 1 ? recordTypeParams[0] : 'all';

  const accountProductsParams = {
    visible_in_inventory: true,
    search: search || undefined,
    record_type: recordType,
    inventory: 'available',
    ordering: '-created_at'
  };

  const {
    query: { data, isLoading, isFetched, isFetching },
    pagination
  } = usePaginatedQuery({
    queryKey: [apiPaths.accountProducts, accountProductsParams],
    queryFn: (limit, offset) => {
      return accountProductsApi.fetch({ limit, offset, ...accountProductsParams });
    },
    queryOptions: {
      select: queryData => ({
        ...queryData,
        results: queryData.results.map(mapProductToProof)
      })
    },
    perPageOptions
  });

  const products = data?.results ?? [];

  if (isLoading) return <Loader />;

  return <SelectProducts products={products} pagination={pagination} isFetching={!isFetched && isFetching} />;
};

const steps = [
  { step: 'select-products', label: 'Select Products' },
  { step: 'select-recipients', label: 'Select Recipients' },
  { step: 'payment', label: 'Payment' }
];

const SendSwag = () => {
  const { step } = useParams();
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  React.useEffect(() => {
    return () => {
      const isLeavingSendSwag = ['/send-swag', '/import-contacts/'].every(
        path => !history.location.pathname.includes(path)
      );
      if (isLeavingSendSwag) {
        dispatch(cleanShipmentGroup);
      }
    };
  }, [dispatch, history]);

  const stepNumber = steps.findIndex(s => s.step === step);
  const handleGoBack = stepNumber <= 0 && !location.state?.from ? () => history.push('/') : history.goBack;

  const handleContinueToCheckout = () => history.push('/send-swag/payment');

  return (
    <Box
      height="100vh"
      display="flex"
      flexDirection="column"
      overflow={step !== 'payment' ? 'hidden' : undefined}
      bgcolor="#fff"
    >
      <TopBar onGoBack={handleGoBack}>
        <Stepper steps={steps} active={stepNumber} />
      </TopBar>
      <Switch>
        <Route path="/send-swag/select-products">
          <SelectProductsWrapper />
        </Route>
        <Route path="/send-swag/select-recipients/">
          <SelectRecipients step="select-recipients" limitedStock onCreate={handleContinueToCheckout} />
        </Route>
        <Route path="/send-swag/payment">
          <ShipmentsReview />
        </Route>
        <Redirect to="/send-swag/select-products" />
      </Switch>
    </Box>
  );
};

export default SendSwag;
